// extracted by mini-css-extract-plugin
module.exports = {"sidebarItemHover":"sidebar_sidebarItemHover__3ESE5","navlabel":"sidebar_navlabel__3R6gf","iconHover":"sidebar_iconHover__1_w5u","sidebarLink":"sidebar_sidebarLink__3kpxx"};